import React, { FC, SetStateAction, createContext, useContext, useState } from "react";
import { IBenhNhan } from "./models/IPhongBenh";
import { WithChildren } from "../../../_metronic/helpers";
import { IDichVu } from "./models/IDichVu";

type PhanHeNoiTruContextProps = {
  patientByRoom: IBenhNhan;
  setPatientByRoom: React.Dispatch<SetStateAction<IBenhNhan>>;
  servicesByPatient: IDichVu[];
  setServicesByPatient: React.Dispatch<SetStateAction<IDichVu[]>>;
  benhNhanHanhChinh: any;
  setBenhNhanHanhChinh: React.Dispatch<SetStateAction<any>>;
  statusChangedEvent: any;
  statusChangedEventFunc: () => void;
}

const initState = {
  benhNhanHanhChinh: {},
  setBenhNhanHanhChinh: () => {},
  patientByRoom: {},
  setPatientByRoom: () => {},
  servicesByPatient: [],
  setServicesByPatient: () => {},
  statusChangedEvent: false,
  statusChangedEventFunc: () => {},
}

export const PhanHeNoiTruContext = createContext<PhanHeNoiTruContextProps>(initState);

const PhanHeNoiTruProvider: FC<WithChildren> = ({children}) => {
  const [patientByRoom, setPatientByRoom] = useState<IBenhNhan>({});
  const [servicesByPatient, setServicesByPatient] = useState<IDichVu[]>([]);
  const [benhNhanHanhChinh, setBenhNhanHanhChinh] = useState<any>({});
  const [statusChangedEvent, setStatusChangedEvent] = useState<number>();
  const statusChangedEventFunc = () => { setStatusChangedEvent(Math.random()); }

  const value = { 
    patientByRoom, setPatientByRoom, 
    servicesByPatient, setServicesByPatient,
    benhNhanHanhChinh, setBenhNhanHanhChinh,
    statusChangedEvent, statusChangedEventFunc
  };
  return (
    <PhanHeNoiTruContext.Provider value={value}>
      {children}
    </PhanHeNoiTruContext.Provider>
  )
}
export default PhanHeNoiTruProvider;

export const usePhanHeNoiTruContext = () => useContext(PhanHeNoiTruContext);
